import { useState } from "react";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
import { useUrlFilterState } from "../../hooks/useUrlFilterState";
// State Import
import { useItemList } from "../../state/itemListState";
// Component imports
import { GenericListHeader } from "../../components/GenericHeader";
import { ItemTableFilterBar } from "../../components/ItemTableFilterBar";
import { ItemTable } from "../../components/ItemTable";

export function ItemList() {
  const [items, setItems] = useState({
    filter: {},
    item: [],
    paging: {},
  });

  const [itemFilter, setItemFilter] = useUrlFilterState(
    {
      wardrobeID: null,
      search: "",
      page: 1,
      pageSize: 25,
    },
    { exclude: ["wardrobeID", "pageSize"] },
  );

  const { isPending, isError, data, error, isFetching, isSuccess } =
    useItemList(itemFilter);

  // Success Function
  const successFunc = () => {
    setItems(data.data.data.data.list);
  };

  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <>
      <GenericListHeader heading={"All Items"} />
      <ItemTableFilterBar
        itemFilter={itemFilter}
        setItemFilter={setItemFilter}
      />
      {isError && <span>Error: {error.message}</span>}
      <ItemTable
        data={items}
        loading={isFetching}
        itemFilter={itemFilter}
        setItemFilter={setItemFilter}
      />
    </>
  );
}
